export const MonsterEffectValidElement =  ()=>{
    return (
        <div className="container">
            カードが指定された効果タイプで有効かを表します
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_monster_effect_valid.png`}></img></p>
        </div>
    )
}
